import React from 'react';
import { Link } from 'react-router-dom';
import styles from '@/assets/styles/Footer.module.less';
import Wechat from '@/assets/img/wechat.jpg';
import { INFO } from '@/utils/constant/info';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerContent}>
          {/* 网站导航 */}
          <div className={styles.footerSection}>
            <h4 className={styles.footerTitle}>产品服务</h4>
            <ul className={styles.footerLinks}>
              <li>
                <Link to="/">首页</Link>
              </li>
              <li>{/* <Link to="/applications">应用工具</Link> */}</li>
              <li>
                <Link to="/dictionary">词典</Link>
              </li>
              <li>
                <Link to="/discover">发现</Link>
              </li>
            </ul>
          </div>

          {/* 工具链接 */}
          <div className={styles.footerSection}>
            <h4 className={styles.footerTitle}>工具</h4>
            <ul className={styles.footerLinks}>
              <li>
                <Link to="/applications/text-analyze">文本分析</Link>
              </li>
              <li>
                <Link to="/vocabulary">我的词汇</Link>
              </li>
              <li>
                <Link to="/profile">我的账号</Link>
              </li>
            </ul>
          </div>

          {/* 法律信息 */}
          <div className={styles.footerSection}>
            <h4 className={styles.footerTitle}>法律信息</h4>
            <ul className={styles.footerLinks}>
              <li>
                <Link to="/privacy-policy">隐私声明</Link>
              </li>
              <li>
                <Link to="/terms-of-service">服务条款</Link>
              </li>
            </ul>
          </div>

          {/* 二维码区域 */}
          <div className={styles.footerSection}>
            <h4 className={styles.footerTitle}>关于我们</h4>
            <div className={styles.qrContainer}>
              <div className={styles.qrCode}>
                <img src={Wechat} alt="Wechat" />
              </div>
              <p className={styles.qrText}>微信公众号：胡哩胡唠</p>
            </div>
          </div>
        </div>

        {/* 版权信息 */}
        <div className={styles.footerBottom}>
          <div className={styles.copyright}>
            © 2024~2025 Furiflow.com All Rights Reserved. |
            <span className={styles.version}>{INFO.version}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
